/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */

/**
 * Column the entries of a vehicle are sorted by. Travels as an int — never renumber.
 */
export type FacilityFlowCoreModulesFleetDtosVehicleLogbookSort = typeof FacilityFlowCoreModulesFleetDtosVehicleLogbookSort[keyof typeof FacilityFlowCoreModulesFleetDtosVehicleLogbookSort];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FacilityFlowCoreModulesFleetDtosVehicleLogbookSort = {
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
  NUMBER_6: 6,
  NUMBER_7: 7,
  NUMBER_8: 8,
  NUMBER_9: 9,
  NUMBER_10: 10,
} as const;
